import {api} from "./api";
import {MODERATOR_NOTIFICATION} from "../mock/URLs";
import {GetNotificationResponse} from "../types/notification";

type GetNotification = {
  params?: {
    page?: number;
    page_size?: number;
    search?: string;
  }
}
export const getNotifications = async ({params}: GetNotification) => {
  try {
    const {data} = await api.get<GetNotificationResponse>(MODERATOR_NOTIFICATION, {
      params
    })
    return data;
  } catch (e) {
    throw e
  }
}

export const createNotification = async (data: FormData) => {
  try {
    const response = await api.post(MODERATOR_NOTIFICATION, data)
    return response.data
  } catch (e) {
    throw e
  }
}